import React from 'react'
import './stylesheet/contactus.css'

export const ContactUs = () => {
    return (
        <>
            <div className="contact_us"><a href="#contact">Contact us for any help</a></div>
        </>
    )
}
